import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { domainName } from '../../config';
import { useLocation, useHistory } from 'react-router-dom';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

type Props = {
    debug: any;
    mod: string;
    url: string;
};

export function Share(props: Props) {
    const { mod, url } = props;
    const { pathname } = useLocation();



    const [value, setValue] = useState(`https://${domainName}${pathname}`);
    const [copied, setCopied] = useState(false);
    const [visible, setVisible] = useState(true);
    const show = () => setVisible(true);
    const hide = () => setVisible(false);

    useEffect(() => {
        setVisible(false);
    }, []);

    useEffect(() => {
        // const  history  = useHistory();
        // console.log('history: ', history);
        // const params = history.location.search;
        // console.log('params: ', params);
    },[])

    return (
        <>
            {mod !== 'quiz' && (
                <div className="share article__share">
                    <div className="share__title">Поделиться</div>
                    <ul className="share__list">
                        <li className="share__item">
                            <a
                                href={`https://telegram.me/share/url?url=https://${domainName}${pathname}`}
                                target="_blank"
                                className="share__link"
                            >
                                <svg className="share__icon">
                                    <use href="/img/icons/icons.svg#svg-share-telegram"></use>
                                </svg>
                            </a>
                        </li>
                        <li className="share__item">
                            <a
                                href={`https://vk.com/share.php?url=https://${domainName}${pathname}`}
                                target="_blank"
                                className="share__link"
                            >
                                <svg className="share__icon">
                                    <use href="/img/icons/icons.svg#svg-share-vk"></use>
                                </svg>
                            </a>
                        </li>
                        <li className="share__item">
                            <a
                                href={`https://connect.ok.ru/offer?url=https://${domainName}${pathname}`}
                                target="_blank"
                                className="share__link"
                            >
                                <svg className="share__icon">
                                    <use href="/img/icons/icons.svg#svg-share-od"></use>
                                </svg>
                            </a>
                        </li>
                        <CopyToClipboard
                            options={{
                                debug: props.debug,
                                message: 'Скопировано',
                            }}
                            text={value}
                            onCopy={() => setCopied(true)}
                        >
                            <li className="share__item">
                                <Tippy
                                    content="Скопировано"
                                    visible={visible}
                                    onClickOutside={hide}
                                >
                                    <a
                                        className="share__link"
                                        onClick={visible ? hide : show}
                                    >
                                        <svg className="share__icon">
                                            <use href="/img/icons/icons.svg#svg-share"></use>
                                        </svg>
                                    </a>
                                </Tippy>
                            </li>
                        </CopyToClipboard>
                    </ul>
                </div>
            )}
            {mod === 'quiz' && (
                <div className="share-quiz quiz__share">
                    <div className="share-quiz__title">Поделиться</div>
                    <ul className="share-quiz__list">
                        <li className="share-quiz__item">
                            <a
                                href={!url ? `https://telegram.me/share/url?url=${domainName}${pathname}` : `https://telegram.me/share/url?url=${url}`}
                                target="_blank"
                                className="share-quiz__link"
                            >
                                <svg className="share-quiz__icon">
                                    <use href="/img/icons/icons.svg#svg-share-telegram"></use>
                                </svg>
                            </a>
                        </li>
                        <li className="share-quiz__item">
                            <a
                                href={!url ? `https://vk.com/share.php?url=${domainName}${pathname}` : `https://vk.com/share.php?url=${url}`}
                                target="_blank"
                                className="share-quiz__link"
                            >
                                <svg className="share-quiz__icon">
                                    <use href="/img/icons/icons.svg#svg-share-vk"></use>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </>
    );
}
